// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import {
  MDBCol,
  MDBRow,
  MDBTable,
  MDBTableBody,
} from 'mdbreact';
import { connect } from 'react-redux';
import { toggleModal, toggleSecondModalClose } from '../../storage/actions/modalsActions';
import {
  setCurrentApplicants,
  assignContractor,
  unRouteWorkOrder,
  sendRecruitMail,
  acceptInvite,
} from '../../storage/actions/workOrdersActions';
import ApplicantCard from '../layout/contractorCards/ApplicantCard';
import InvitedContractorCard from '../layout/contractorCards/InvitedContractorCard';

const ViewAllApplicantsForWorkOrder = ({
  userType,
  modalState,
  toggleModal: toggleModalAction,
  toggleSecondModalClose,
  applicants,
  routedApplicants,
  setCurrentApplicants,
  applicantsLoaded,
  routedApplicantsLoaded,
  currentWorkOrder,
  assignContractor,
  unRouteWorkOrder,
  sendRecruitMail,
  acceptInvite,
}) => {
  const [recruitBoostSent, setRecruitBoostSent] = useState(false);

  useEffect(() => {
    setRecruitBoostSent(Boolean(currentWorkOrder?.recruitMailSent));
  }, [currentWorkOrder?._id, currentWorkOrder?.recruitMailSent]);

  const handlerSendRecruitMail = () => {
    if (recruitBoostSent || currentWorkOrder.isRemote) return;
    setRecruitBoostSent(true);
    sendRecruitMail(currentWorkOrder._id);
  };

  const closeModal = () => {
    const fromWorkOrderDetails = modalState?.type?.fromWorkOrderDetails;
    toggleSecondModalClose('viewAllApplicantsForWorkOrderModal', true);
    if (fromWorkOrderDetails) {
      toggleModalAction(true, 'viewDetailsWorkOrderModal', true);
    }
  };

  if (!(modalState?.isOpen && applicantsLoaded && routedApplicantsLoaded)) {
    return null;
  }

  return (
    <div
      className="dashboard-modal dashboard-modal--open dashboard-modal--applicants"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="dashboard-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="wo-applicants-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dashboard-modal-header">
          <h4 className="dashboard-modal-title" id="wo-applicants-title">
            Applicants
          </h4>
          <button
            type="button"
            className="dashboard-modal-close"
            aria-label="Close applicants"
            onClick={closeModal}
          />
        </div>

        <div className="dashboard-modal-body wurqly-modal-scroll dashboard-modal-form-scroll">
          <MDBRow style={{ marginBottom: '15px' }}>
            <MDBCol md="6">
              <h4 style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                {`Number of Applicants: ${applicants.contractor ? applicants.contractor.length : '0'}`}
              </h4>

              <button
                type="button"
                title={recruitBoostSent
                  ? 'RecruitBoost emails have already been sent for this work order.'
                  : 'RecruitBoost is a tool that automatically sends a work available notification to all potential candidates within that area to help draw applicants to your job.'}
                className="dashboard-btn dashboard-btn--secondary"
                disabled={currentWorkOrder.isRemote || recruitBoostSent}
                onClick={handlerSendRecruitMail}
              >
                {recruitBoostSent ? 'RecruitBoost Sent' : <>RecruitBoost <span className="recruit-tm">TM</span></>}
              </button>

              <br />
              <span style={{ color: '#e87b68', marginTop: '10px' }}>
                {applicants.message}
              </span>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol>
              <MDBTable className="applicantappiliedwo_table" style={{ width: '100%' }}>
                {applicants.contractor && (
                  <MDBTableBody>
                    {applicants.contractor.map(contractor => (
                      contractor.contractor_details ? (
                        <tr key={contractor.contractor_details.unique_id}>
                          <td>
                            <ApplicantCard
                              contractorInfo={contractor}
                              setCurrentApplicants={setCurrentApplicants}
                              toggleModal={toggleModalAction}
                              currentWorkOrder={currentWorkOrder}
                              assignContractor={assignContractor}
                              userType={userType}
                            />
                          </td>
                        </tr>
                      ) : null
                    ))}
                  </MDBTableBody>
                )}
              </MDBTable>
            </MDBCol>
          </MDBRow>

          <MDBRow style={{ marginBottom: '15px' }}>
            <MDBCol md="6">
              <h4 style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                {`Applicants Invited: ${routedApplicants.data ? routedApplicants.data.length : '0'}`}
              </h4>
              <span style={{ color: '#e87b68' }}>
                {routedApplicants.message}
              </span>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol>
              <MDBTable className="applicantappiliedwo_table">
                {routedApplicants.data && (
                  <MDBTableBody>
                    {routedApplicants.data.map(contractor => (
                      contractor.contractor_details ? (
                        <InvitedContractorCard
                          key={contractor.contractor_id}
                          userType={userType}
                          contractorInfo={contractor}
                          toggleModal={toggleModalAction}
                          setCurrentApplicants={setCurrentApplicants}
                          currentWorkOrder={currentWorkOrder}
                          unRouteWorkOrder={unRouteWorkOrder}
                          acceptInvite={acceptInvite}
                        />
                      ) : null
                    ))}
                  </MDBTableBody>
                )}
              </MDBTable>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  setCurrentApplicants,
  assignContractor,
  unRouteWorkOrder,
  acceptInvite,
  sendRecruitMail,
  toggleSecondModalClose,
};

const mapStateToProps = state => ({
  currentWorkOrder: state.workOrder.currentWorkOrder,
  applicantsLoaded: state.workOrder.applicantsLoaded,
  routedApplicantsLoaded: state.workOrder.routedApplicantsLoaded,
  applicants: state.workOrder.applicants,
  routedApplicants: state.workOrder.routedApplicants,
  modalState: state.modalState.viewAllApplicantsForWorkOrderModal,
  userType: state.auth?.user?.userType,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllApplicantsForWorkOrder);
